import { controls, currencyToNumber, grouped, checkCondition } from "../../controls";
const montly_in_out_attendnace = {
  label: "Montly In Out Attendance",
  url: "montly_in_out_attendnace",
  pageLabel: "Montly In Out Attendance",
  pageType: "history",
  filter: [
    ...controls.displayText({
      tab: "filter", label: "Employee",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employee_code", controlType: "Employee", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({
      tab: "filter", label: "Branch",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "branch_code", controlType: "Branch", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "general", label: "Month", target: "month", star: true }),
    ...controls.magicDate({ tab: "general", name: "salary_month", dateType: "monthYear", isRequired: true, isReadOnly: "edit", displayFormat: "MMMM yyyy" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({
      tab: "filter", label: "Employement Status",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employment_status_code", controlType: "EmploymentStatus", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),



    //    ...controls.magicDateLabel({ tab: "general", label: "From Date",target: "from_date"}),
    //    ...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype"}),
    //    ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),

    //    ...controls.magicDateLabel({ tab: "general", label: "To Date",target: "to_date"}),
    //    ...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype"}),
    //  //  ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Montly In Out Attendance",
    pdfProps: {
      pageSize: "A4", pageOrientation: "landscape",
      header: [
        [
          { source: 'fixed', value: 'Salary Month' }, { source: 'fixed', value: '::' },
          { field: "salary_month" }, { source: 'fixed', value: '\n' },
        ]
      ]

    },

    filterable: true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `Montly In Out Attendance-$pageData.as_on_date$.oro`,
        empty: true,//true
        format: {},
        header: "default",
        footer: "default"
      },
    },
    reportProps: { searchable: true, sortable: true },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },

      {
        Header: "Employee Code",
        accessor: "employee_code",

      },
      {
        Header: "Employee Name",
        accessor: "employee_display",


      },
      {
        Header: " 01-In",
        accessor: "2022-12-01_in_time",
        // back: (d) => checkCondition(d['2022-12-01_in_time']) == true ? "red" : "green"
      },
      {
        Header: "01-Out",
        accessor: "2022-12-01_out_time",
        //back: (d) => checkCondition(d['2022-12-01_out_time']) == true ? "red" : "green"

      },

      {
        Header: "02-In ",
        accessor: "2022-12-02_in_time",
        //back: (d) => checkCondition(d['2022-12-02_in_time']) == true ? "red" : "green"
      },
      {
        Header: "02-Out ",
        accessor: "2022-12-02_out_time",
        //back: (d) => checkCondition(d['2022-12-02_out_time']) == true ? "Red" : "Green"

      },
      {
        Header: "03-In ",
        accessor: "2022-12-03_in_time",
        //back: (d) => checkCondition(d['2022-12-03_in_time']) == true ? "Red" : "Green"
      },
      {
        Header: "03-Out ",
        accessor: "2022-12-03_out_time",
        //back: (d) => checkCondition(d['2022-12-03_out_time']) == true ? "Red" : "Green"

      },


      {
        Header: "04-In",
        accessor: "2022-12-04_in_time",
        //back: (d) => checkCondition(d["2022-12-04_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "04-Out",
        accessor: "2022-12-04_out_time",
        // back: (d) => checkCondition(d["2022-12-04_out_time"]) > true ? "Red" : "Green"

      },

      {
        Header: "05-In",
        accessor: "2022-12-05_in_time",
        // back: (d) => checkCondition(d["2022-12-05_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "05-Out",
        accessor: "2022-12-05_out_time",
        //back: (d) => checkCondition(d["2022-12-05_out_time"]) > true ? "Red" : "Green"

      },
      {
        Header: "06-In",
        accessor: "2022-12-06_in_time",
        //back: (d) => checkCondition(d["2022-12-06_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "06-Out",
        accessor: "2022-12-06_out_time",
        // back: (d) => checkCondition(d["2022-12-06_out_time"]) > true ? "Red" : "Green"

      },
      {
        Header: "07-In",
        accessor: "2022-12-07_in_time",
        //back: (d) => checkCondition(d["2022-12-07_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "07-Out",
        accessor: "2022-12-07_out_time",
        // back: (d) => checkCondition(d["2022-12-07_out_time"]) > true ? "Red" : "Green"

      },
      {
        Header: "08-In",
        accessor: "2022-12-08_in_time",
        //back: (d) => checkCondition(d["2022-12-08_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "08-Out",
        accessor: "2022-12-08_out_time",
        //back: (d) => checkCondition(d["2022-12-08_out_time"]) > true ? "Red" : "Green"

      },
      {
        Header: "09-In",
        accessor: "2022-12-09_in_time",
        //back: (d) => checkCondition(d["2022-12-09_in_time"]) > true ? "Red" : "Green"
      },
      {
        Header: "09 Out",
        accessor: "2022-12-09_out_time",
        //back: (d) => checkCondition(d["2022-12-09_out_time"]) > true ? "Red" : "Green"

      },
      {
        Header: "10 In ",
        accessor: "2022-12-10_in_time"
      },
      {
        Header: "10 Out",
        accessor: "2022-12-10_out_time"

      },

      {
        Header: "11 In",
        accessor: "2022-12-11_in_time"
      },
      {
        Header: "11 Out",
        accessor: "2022-12-11_out_time"

      },

      {
        Header: "12 In",
        accessor: "2022-12-12_in_time"
      },
      {
        Header: "12 Out",
        accessor: "2022-12-12_out_time"

      },


      {
        Header: "13 In ",
        accessor: "2022-12-13_in_time"
      },
      {
        Header: "13 Out ",
        accessor: "2022-12-13_out_time"

      },


      {
        Header: "14 In ",
        accessor: "2022-12-14_in_time"
      },
      {
        Header: "14 Out ",
        accessor: "2022-12-14_out_time"

      },

      {
        Header: "15 In ",
        accessor: "2022-12-15_in_time"
      },
      {
        Header: "15 Out",
        accessor: "2022-12-15_out_time"

      },

      {
        Header: "16 In ",
        accessor: "2022-12-16_in_time"
      },
      {
        Header: "16 Out ",
        accessor: "2022-12-16_out_time"

      },
      {
        Header: "17 In ",
        accessor: "2022-12-17_in_time"
      },
      {
        Header: "17 Out ",
        accessor: "2022-12-17_out_time"

      },
      {
        Header: "18 In ",
        accessor: "2022-12-18_in_time"
      },
      {
        Header: "18 Out ",
        accessor: "2022-12-18_out_time"

      },
      {
        Header: "19 In ",
        accessor: "2022-12-19_in_time"
      },
      {
        Header: "19 Out ",
        accessor: "2022-12-19_out_time"

      },

      {
        Header: "20 In ",
        accessor: "2022-12-20_in_time"
      },
      {
        Header: "20 Out ",
        accessor: "2022-12-20_out_time"

      },

      {
        Header: "21 In ",
        accessor: "2022-12-21_in_time"
      },
      {
        Header: "21 Out ",
        accessor: "2022-12-21_out_time"

      },

      {
        Header: "22 In ",
        accessor: "2022-12-22_in_time"
      },
      {
        Header: "22 Out ",
        accessor: "2022-12-22_out_time"

      },


      {
        Header: "23 In ",
        accessor: "2022-12-23_in_time"
      },
      {
        Header: "23 Out ",
        accessor: "2022-12-23_out_time"

      },




      {
        Header: "24 In ",
        accessor: "2022-12-24_in_time"
      },
      {
        Header: "24 Out ",
        accessor: "2022-12-24_out_time"

      },


      {
        Header: "25 In ",
        accessor: "2022-12-25_in_time"
      },
      {
        Header: "25 Out ",
        accessor: "2022-12-25_out_time"

      },


      {
        Header: "26 In ",
        accessor: "2022-12-26_in_time"
      },
      {
        Header: "26 Out ",
        accessor: "2022-12-26_out_time"

      },

      {
        Header: "27 In ",
        accessor: "2022-12-27_in_time"
      },
      {
        Header: "27 Out ",
        accessor: "2022-12-27_out_time"

      },
      {
        Header: "28 In ",
        accessor: "2022-12-28_in_time"
      },
      {
        Header: "28 Out ",
        accessor: "2022-12-28_out_time"

      },

      {
        Header: "29 In ",
        accessor: "2022-12-29_in_time"
      },
      {
        Header: "29 Out ",
        accessor: "2022-12-29_out_time"

      },
      {
        Header: "30 In ",
        accessor: "2022-12-30_in_time"
      },
      {
        Header: "30 Out ",
        accessor: "2022-12-30_out_time"

      },
      {
        Header: "31 In ",
        accessor: "2022-12-31_in_time"
      },
      {
        Header: "31 Out",
        accessor: "2022-12-31_out_time"

      }


    ]
  }
};

export default montly_in_out_attendnace;
